/**
 * Created by griga on 7/11/16.
 */

import { Routes, RouterModule, CanActivate } from '@angular/router';
import { MainLayoutComponent } from './shared/layout/app-layouts/main-layout.component';
import { AuthLayoutComponent } from './shared/layout/app-layouts/auth-layout.component';
import { ModuleWithProviders } from '@angular/core';

// import { AuthGuardService as AuthGuard } from './+auth/common/services/auth-guard.service';

export const routes: Routes = [
    {
        path: '',
        component: MainLayoutComponent,
        data: { pageTitle: 'Home' },
        children: [
            //   {
            //     path: '', redirectTo: 'dashboard/analytics', pathMatch: 'full'
            //   },
            //   {
            //     path: '',
            //     redirectTo: 'master-data/customers',
            //     pathMatch: 'full'
            //   },
            //   {
            //     path: '',
            //     redirectTo: 'master-data/structures',
            //     pathMatch: 'full'
            //   },
            {
                path: 'master-data',
                loadChildren: 'app/+master-data/master-data.module#MasterDataModule',
                data: { pageTitle: 'Master Data' }
            },
            {
                path: 'core',
                loadChildren: 'app/+core/core.module#CoreModule',
                data: { pageTitle: 'Core' }
            },
            {
                path: 'common',
                loadChildren: 'app/+common/common.module#CommonApplicationModule',
                data: { pageTitle: 'Common' }
            },
            {
                path: 'admin',
                loadChildren: 'app/+admin/admin.module#AdminModule',
                data: { pageTitle: 'Admin' }
            },       
            {
                path: 'dashboard',
                loadChildren: 'app/+dashboard/dashboard.module#DashboardModule',
                data: { pageTitle: 'Dashboard' }
            },
            {
                path: 'smartadmin',
                loadChildren:
                    'app/+smartadmin-intel/smartadmin-intel.module#SmartadminIntelModule',
                data: { pageTitle: 'Smartadmin' }
            },
            {
                path: 'calendar',
                loadChildren: 'app/+calendar/calendar.module#CalendarModule'
            },
            {
                path: 'graphs',
                loadChildren: 'app/+graphs/graphs-showcase.module#GraphsShowcaseModule',
                data: { pageTitle: 'Graphs' }
            },
            {
                path: 'miscellaneous',
                loadChildren:
                    'app/+miscellaneous/miscellaneous.module#MiscellaneousModule',
                data: { pageTitle: 'Miscellaneous' }
            }
        ]
    },
    {
        path: 'auth',
        component: AuthLayoutComponent,
        loadChildren: 'app/+auth/auth.module#AuthModule'
    },

    { path: '**', redirectTo: 'miscellaneous/error404' }
];

export const routing: ModuleWithProviders = RouterModule.forRoot(routes, {
    useHash: true
});



// WEBPACK FOOTER //
// ./src/app/app.routing.ts